import React from 'react';

import { LoadableLazy } from '@confluence/loadable';

import { useIsStorageEnforcementEligible } from '../../hooks/useIsStorageEnforcementEligible.ts';

const BlockCreateModalLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlockCreateModalLoadable" */ './BlockCreateModal.tsx'
			)
		).BlockCreateModal,
});

export const BlockCreateModal = () => {
	const isEligibleUser = useIsStorageEnforcementEligible();
	return isEligibleUser ? <BlockCreateModalLoadable /> : null;
};
